const normalizeFlag = (value: string | undefined, defaultValue = '0'): boolean => {
  const normalized = (value ?? defaultValue).toString().trim().toLowerCase();
  if (!normalized) return false;
  return normalized === '1' || normalized === 'true' || normalized === 'yes';
};

export const featureFlags = {
  strategyAdmin: normalizeFlag(import.meta.env.VITE_FEATURE_STRATEGY_ADMIN, '0'),
  aiAutopilot: normalizeFlag(import.meta.env.VITE_FEATURE_AI_AUTOPILOT, '1'),
  aiAssistant: normalizeFlag(import.meta.env.VITE_FEATURE_AI_ASSISTANT, '1'),
  aiAssistantDebug: normalizeFlag(import.meta.env.VITE_FEATURE_AI_ASSISTANT_DEBUG, '0'),
  smartRouting: normalizeFlag(import.meta.env.VITE_FEATURE_SMART_ROUTING, '1'),
};

export type FeatureFlags = typeof featureFlags;
